import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inst-title" }, "파일 확장자 검사", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "현재 한양3D팩토리가 지원하는 파일 확장자는 STL, OBJ, STEP 파일입니다.\n      잘못된 확장자 변환을 시도하거나, 파일이 손상된 경우  문제가 발생하게 됩니다.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inst-subtitle" }, "[해결방법]", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "다른 3D 프로그램에서도 해당 파일이 잘 불러와 지는지 확인", -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_5))
}